import { getLanguageList } from "@Src/features/UserProfile/Services/UserProfile.sevice";
import { setLanguageName } from "@Src/app/reducers/auth/loginSlice";
import { APIResponse, APIStatus } from "@Src/services/baseInterfaces";

export const syncLanguageName = async (languageId: number, dispatch: any) => {
    if (!languageId) {
        // console.log("No languageId provided, skipping sync");
        return;
    }

    // console.log("🔄 Syncing Language Name for ID:", languageId);
    try {
        const response: APIResponse = await getLanguageList();
        // console.log("📡 Language API Response:", response);
        
        if (response.ResponseType === APIStatus.SUCCESS && response.data) {
            // console.log("✅ Language List Fetched:", response.data);
            const langObj = response.data.find((l: any) => l.Id == languageId);
            if (langObj) {
                // console.log("🎯 Found Language Name:", langObj.Name, "for ID:", languageId);
                dispatch(setLanguageName(langObj.Name));
                // console.log("✅ Language name dispatched to Redux");
            } else {
                console.warn("⚠️ Language ID not found in list:", languageId);
                // console.log("Available language IDs:", response.data.map((l: any) => l.Id));
                // Fallback: set a default name based on common language IDs
                const fallbackName = languageId === 1 ? 'English' : languageId === 2 ? 'Hindi' : `Language ${languageId}`;
                // console.log("🔄 Using fallback name:", fallbackName);
                dispatch(setLanguageName(fallbackName));
            }
        } else {
            console.error("❌ Failed to fetch language list:", response);
            // Fallback when API fails
            const fallbackName = languageId === 1 ? 'English' : languageId === 2 ? 'Hindi' : `Language ${languageId}`;
            // console.log("🔄 API failed, using fallback name:", fallbackName);
            dispatch(setLanguageName(fallbackName));
        }
    } catch (error) {
        console.error("💥 Failed to sync language name", error);
        // Fallback when everything fails
        const fallbackName = languageId === 1 ? 'English' : languageId === 2 ? 'Hindi' : `Language ${languageId}`;
        // console.log("🔄 Exception occurred, using fallback name:", fallbackName);
        dispatch(setLanguageName(fallbackName));
    }
};
